import Vue from 'vue';
import Modal from "./Modal";

Vue.component('modal', Modal);